import styled, { css } from "styled-components";

export const InputHeaderTitle = styled.h5`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 5px;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }

  @media (max-width: 375px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const SmallText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 5px;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 18px;
  }

  @media (max-width: 375px) {
    font-size: 13px;
    line-height: 17px;
  }
`;

export const CheckBoxAlignment = styled.div`
  display:flex !important
  flex-flow:column !important
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1382px;
`;

export const GreyText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  color: var(--vds-color-elements-secondary, #6f7171);
  margin-bottom: 10px;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 18px;
  }

  @media (max-width: 375px) {
    font-size: 13px;
    line-height: 17px;
  }
`;

export const GreySmallText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  color: var(--vds-color-elements-secondary, #6f7171);
  margin-bottom: 10px;

  @media (max-width: 767px) {
    font-size: 11px;
    line-height: 15px;
  }

  @media (max-width: 375px) {
    font-size: 10px;
    line-height: 14px;
  }
`;

export const EllipsisContainer = styled.div`
  display: inline;
  cursor: pointer;
  position: relative;
  &:hover.full-list {
    // display: block;
  }
`;

export const FullUserList = styled.div`
display:none;
position:absolute;
background-color:white;
border: 1px solid #6F7171;
padding:5px;
z-index:1
max-width:200px;
white-space :nowrap;
`;

export const SetTriggerContainer = styled.div`
width: 850px;
max-height: 500px;
height:auto
width:auto
padding: 24px 24px 48px 24px;
overflow-y: ${(props) => (props?.isEditing ? "" : "auto")};
`;

export const AlertPreferences = styled.div`
width: 165px;
height: 64px;
gap: 8px;
opacity: 0px;
margin-top:-8px
margin-right:10px;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    flex-basis: 40%
  }
`;

export const ActionsInsideFrame = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  max-width: 657px;
  height: auto;
  gap: 40px;
  flex-wrap: nowrap;

  @media (max-width: 479px) {
    max-width: 100%;
  }
`;

export const UserGroupsFrame = styled.div`
  width: 100%;
  height: auto;
  gap: 12px;
  max-width: 553px;
  max-height: 192px;
  width: 100%
  height: auto;
  margin-top:-40px;

  @media (max-width: 479px) {
    max-width: 100%;
    max-height: none;
    flex-direction: column;
  }
`;

export const UserHeadingText = styled.h5`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;
  margin-top: -40px;
`;
export const TimeFrameText = styled.h5`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-top: 20px;
`;

export const UserGroupOptions = styled.div`
  max-width: 328px;
  width: 100%;
  height: 200px;
  margin-left: 1px;
  margin-top: -10px;
`;

export const UserGroupContainer = styled.div`
  border: none;
  max-width: 553px;
  width: 100%;

  @media (max-width: 768px) {
    flex-basis: 50%;
    max-height: 50%;
    overflow-y: auto;
  }
`;

export const AlertNameInputFrame = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${(props) => (props.timeFrame ? "912px" : "328px")};
  height: auto;
  min-height: 64px;
  gap: 40px;

  @media (max-width: 1000px) {
    max-width: 80vw;
  }
`;

export const ActionsFrame = styled.div`
  max-width: 752px;
  max-height: 500px;
  width: 100%
  height: auto;
  gap: 8px;

  @media (max-width: 479px) {
    max-height: none;
  }
`;

export const AlertNameFrameAndTimeFrame = styled.div`
  width: 100%;
  max-width: 852px;
  margin-top: 30px;
  height: auto;
  max-height: ${(props) => (props.Action ? "350px" : "136px")};
  gap: 8px;

  @media (max-width: 479px) {
    max-height: none;
    max-width: 70vw;
  }
`;

export const AlertFlexBox = styled.div`
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  flexWrap: 'wrap'
`;
